import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePlayer } from "../player/playerContext";
import { setLoggedIn, trackPageView } from "./analytics";

export default function AnalyticsTracker(): null {
  const location = useLocation();
  const [player] = usePlayer() as [any, any];
  const loggedIn = player?._embedded?.mode === "real";

  useEffect(() => {
    setLoggedIn(loggedIn);
  }, [loggedIn]);

  useEffect(() => {
    // Deferred so the immediate Redirect from "/" to a deep link doesn't log a landing view.
    const timer = setTimeout(() => trackPageView(location.pathname), 0);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}
